import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import api from '../_utility/AxiosConfig';
import BlogGrid from '../component/partials/BlogGrid';

const Blog = () => {
    const [posts, setPosts] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1); // Track the current page
    const [hasMore, setHasMore] = useState(true); // Track if more data is available
    const [shouldAppend, setShouldAppend] = useState(false); // Track if more data is available

    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    const fetchPosts = async (page = 1, append = false) => {
        try {
            const res = await api.post(`/api/posts`, { page });
            const newPosts = res.data.data;
            console.log(res);
            const current_page = res.data.current_page;
            const last_page = res.data.last_page;
            setCurrentPage(current_page);
            setPosts((prevPosts) => (append ? [...prevPosts, ...newPosts] : newPosts));
            setHasMore(current_page < last_page);
        } catch (error) {
            setError('Failed to fetch posts. Please try again later.');
        } finally {
            setError('');
            setLoading(false);
            setShouldAppend(false);
        }
    };

    useEffect(() => {
        setLoading(true);

        fetchPosts(1, false);
    }, []);

    const loadMorePosts = () => {
        setLoading(true);
        setShouldAppend(true);
        if (hasMore) {
            const nextPage = currentPage + 1;
            setCurrentPage(nextPage);
            fetchPosts(nextPage, true); // Fetch and append data
        }
    };

    return (
        <>
            <section>
                <div className="inn-body-section">
                    <div className="container">
                        <div className="page-head">
                            <h2 style={{ 'fontSize': '33px' }}>The Younic Blog: News, Tips & Stories</h2>
                            <div className="head-title">
                                <div className="hl-1"></div>
                                <div className="hl-2"></div>
                                <div className="hl-3"></div>
                            </div>
                            <p>Discover the latest updates, wellness tips, and heartwarming stories from Younic Home — where comfort meets care every day.</p>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <div className="col-sm-11 mx-auto" id="blog">
                            <div class="row">
                                {loading && shouldAppend === false ? (
                                <>
                                    {Array.from({ length: 12 }).map((_, index) => (
                                        <div className="col-xl-3 col-lg-4 col-sm-6 col-12" key={index}>
                                            <div className="ph-item p-0 border-0">
                                                <div className="ph-col-12 p-0">
                                                    <div className="ph-picture"></div>
                                                    <div className="ph-row">
                                                        <div className="ph-col-6"></div>
                                                        <div className="ph-col-4 empty"></div>
                                                        <div className="ph-col-2"></div>
                                                        <div className="ph-col-8"></div>
                                                        <div className="ph-col-4 empty"></div>
                                                        <div className="ph-col-12"></div>
                                                        <div className="ph-col-6"></div>
                                                        <div className="ph-col-6 empty"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            ) : error ? (
                                <div className="alert alert-danger" role="alert">
                                    {error}
                                </div>
                            ) : (
                                <>
                                    <BlogGrid allPosts={posts} loading={loading} currentPage={currentPage}/>
                                </>
                            )}

                            </div>
                            <div className="col-md-12 text-center">
                                {hasMore && posts && posts.length > 0 &&  (
                                    <button
                                        className="waves-effect waves-light pl-5 pr-5 btn btn-lg btn-primary mt-5"
                                        style={{ 'fontSize': '16px' }}
                                        onClick={loadMorePosts}
                                        disabled={loading}
                                    >
                                        {loading ? 
                                            (<><i className="fa fa-refresh fa-spin" aria-hidden="true"></i> Loading...</>) 
                                            : 
                                            (<><i className="fa fa-refresh" aria-hidden="true"></i> Load More</>)
                                        }
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    );
}

export default Blog;
